import { BaseVirtualCard as BaseVirtualCardContainer } from './BaseVirtualCard';
import { CardNumber } from './components/CardNumber';
import { CvvNumber } from './components/CvvNumber';
import { ExpirationDate } from './components/ExpirationDate';
var components = {
  CardNumber,
  ExpirationDate,
  CvvNumber
};
export var BaseVirtualCard = Object.assign(BaseVirtualCardContainer, components);
//# sourceMappingURL=index.js.map